import { UserModel } from ".";

export class ChangePasswordModal {
    public user: UserModel;

    public newPassword: string;
    public newPasswordConf: string;
    public needSendToEmail: boolean;
    public needChange: boolean;
}


// WEBPACK FOOTER //
// ./src/app/core/models/changePasswordModal.model.ts